import {
  QueryClient,
  type QueryClientConfig,
  type UseMutationOptions,
  useQueryClient as _useQueryClient,
} from '@tanstack/react-query';
import { type AxiosError, isAxiosError } from 'axios';

type ExtractFnReturnType<FnType extends (...args: any) => any> = Awaited<
  ReturnType<FnType>
>;

export type MutationConfig<MutationFnType extends (...args: any) => any> =
  UseMutationOptions<
    ExtractFnReturnType<MutationFnType>,
    AxiosError,
    Parameters<MutationFnType>[0]
  >;

const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 1,
      retry: (failureCount, error) => {
        return (
          failureCount <= 3 &&
          isAxiosError(error) &&
          (error.response?.status ?? 500) >= 500
        );
      },
    },
  },
};

let queryClientInstance: QueryClient | null = null;

export const getQueryClient = () => {
  if (!queryClientInstance) {
    queryClientInstance = new QueryClient(queryClientConfig);
  }
  return queryClientInstance;
};

export const useQueryClient = () => {
  return _useQueryClient();
};
